import { z } from "zod";
import { ClassSource } from "@common/types/class";

export const classAssignmentSchema = z.object({
    classId: z.string(),
    rootClassId: z.string(),
});

export type ClassAssignmentSchema = z.infer<typeof classAssignmentSchema>;

export const searchClassesQuerySchema = z.object({
    search: z.string().trim().min(1).max(100),
    limit: z.coerce.number().int().min(1).max(50).default(20),
    cursor: z
        .string()
        .regex(/^(0|[1-9]\d*)$/)
        .optional(),
});

export const searchClassesRowSchema = z.object({
    id: z.string().uuid(),
    label: z.string(),
    path: z.string(),
    parentClassId: z.string().uuid().nullable(),
    parentLabel: z.string().nullable(),
    rootClassId: z.string().uuid(),
    source: z.nativeEnum(ClassSource).nullable(),
    workspaceId: z.string().uuid(),
});

export const searchClassesResponseSchema = z.object({
    rows: z.array(searchClassesRowSchema),
    total: z.number().int().nonnegative(),
    hasMore: z.boolean(),
    nextCursor: z.string().nullable(),
});

export type SearchClassesQuery = z.infer<typeof searchClassesQuerySchema>;
export type SearchClassesResponse = z.infer<typeof searchClassesResponseSchema>;
